import { Language, Translations } from '../types/i18n';
import { en } from './translations/en';
import { es } from './translations/es';

const translations: Record<Language, Translations> = {
  en,
  es,
};

export const getTranslations = (lang: Language): Translations => {
  return translations[lang] || translations.en;
};

export const interpolate = (text: string, values: Record<string, string | number>): string => {
  return text.replace(/{(\w+)}/g, (match, key) => {
    return values[key] !== undefined ? String(values[key]) : match;
  });
};

export { en, es };
export type { Language, Translations };
